module.exports = __webpack_public_path__ + "static/media/DSC_0170.e990cfd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0170.jpg
// module id = 562
// module chunks = 0